import * as Reach from '@reach/menu-button';
import styled from 'styled-components';

import { c07071D, c080820, c1D1D37, mainGridGapColor } from '#/colors';

import { MEDIA } from '#/components/shared/media-queries';
import AssetIcon from '#/components/shared/AssetIcon';

import ChevronDownIcon from '#/assets/ChevronDownIcon';

import { usePerpetualMarketsView } from '#/features/perpetuals/market-info/markets-context';

import MarketsTable from './MarketsTable';
import { POPOVER_PADDING } from './styles';

export default function MarketsMenu() {
  const { activeMarket } = usePerpetualMarketsView();

  if (activeMarket == null) {
    return <div />;
  }

  return (
    <Menu>
      <MenuButton data-testid="active-market-button">
        <AssetIcon asset={activeMarket.symbol} size={21} />
        <MarketTitle>{activeMarket.symbol}</MarketTitle>
        <ArrowIcon />
      </MenuButton>

      <MenuPopover>
        <MarketsTable />
      </MenuPopover>
    </Menu>
  );
}

const Menu = styled(Reach.Menu)``;

const ArrowIcon = styled(ChevronDownIcon).attrs({ strokeWidth: 2 })``;

const MenuButton = styled(Reach.MenuButton)`
  color: inherit;
  border: none;
  background-color: transparent;

  line-height: 1px;
  display: grid;
  align-items: center;
  grid-template-columns: 24px 1fr auto;
  padding: 0 16px;
  gap: 8px;
  border-right: 1px solid ${mainGridGapColor};

  &[aria-expanded='true'] {
    ${ArrowIcon} {
      transform: rotate(180deg);
    }
  }
`;

const MarketTitle = styled.h1`
  font-size: 18px;
  font-weight: 500;
  text-align: start;
`;

const MenuPopover = styled(Reach.MenuList)`
  background-color: ${c080820};
  box-shadow: 10px 10px 24px 0px ${c07071D};
  display: grid;
  padding: ${POPOVER_PADDING}px;
  height: 380px;

  /* 0px – md */
  width: 100vw;

  @media ${MEDIA.md} {
    width: 500px;

    position: relative;
    top: 12px;
    left: 8px;

    border-radius: 7px;
    border: 1px solid ${c1D1D37};
  }
`;
